import { calculateProcessingFeeCents } from './processingFee';

const DEFAULT_BOOKING_SERVICE_FEE_PERCENT = 8;

export const getBookingServiceFeePercent = () => {
  const env = process.env.REACT_APP_BOOKING_SERVICE_FEE_PERCENT;
  const n = Number(env);
  if (Number.isFinite(n) && n >= 0) {
    return Math.round(n);
  }
  return DEFAULT_BOOKING_SERVICE_FEE_PERCENT;
};

const toIntCents = value => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(n);
};

/**
 * @param {{ baseAmountCents: number, feePercent?: number, includeProcessingFee?: boolean }} params
 *
 * includeProcessingFee: true for a card payment estimate -- under $30 the
 * customer also covers Stripe's processing fee. Credits never go through
 * Stripe, so credit checkouts leave it off.
 */
export const calculateBookingFeeBreakdown = ({
  baseAmountCents,
  feePercent = getBookingServiceFeePercent(),
  includeProcessingFee = false,
}) => {
  const base = toIntCents(baseAmountCents);
  const percent = Number.isFinite(Number(feePercent)) ? Number(feePercent) : getBookingServiceFeePercent();
  if (base === null || base < 0) return null;

  const bookingFeeAmountCents = Math.round((base * percent) / 100);
  const processingFeeAmountCents = includeProcessingFee
    ? calculateProcessingFeeCents({ baseAmountCents: base, otherFeesCents: bookingFeeAmountCents })
    : 0;
  const totalAmountCents = base + bookingFeeAmountCents + processingFeeAmountCents;

  return {
    baseAmountCents: base,
    bookingFeePercent: percent,
    bookingFeeAmountCents,
    processingFeeAmountCents,
    totalAmountCents,
    refundableAmountCents: base,
    nonRefundableFeeAmountCents: bookingFeeAmountCents + processingFeeAmountCents,
  };
};

/**
 * @param {number} baseAmountDollars - unit price × quantity in dollars (not cents)
 * @param {number} [feePercent]
 */
export const calculateBookingFeeBreakdownFromDollars = (baseAmountDollars, feePercent, options = {}) => {
  const base = Number(baseAmountDollars);
  if (!Number.isFinite(base) || base < 0) return null;
  return calculateBookingFeeBreakdown({
    baseAmountCents: Math.round(base * 100),
    feePercent,
    includeProcessingFee: Boolean(options.includeProcessingFee),
  });
};

export const formatCentsAsDollars = cents => {
  const n = toIntCents(cents);
  if (n === null) return null;
  return `$${(n / 100).toFixed(2)}`;
};
